import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AutoComplete, Button, Input, Modal, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";

import { getUserInfo } from "../../utils/utils";
import { createGroupExecutiveTag } from "../../actionCreator/executiveListingActionCreater";
import { useAlert } from "../../context/AlertProvider";

const TagExecutive = ({
  title,
  selectedRecords,
  showTagModal,
  callback,
  closeTagModal,
}) => {
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [tagName, setTagValues] = useState();
  const [error, setError] = useState(false);
  const [isExistingTag, setExistingTag] = useState(true);
  const [isOpen, setOpen] = useState();
  const [isAllTagged, setAllTagged] = useState(false);
  const [isCreateTag, setCreateTag] = useState(false);
  const { id } = getUserInfo();
  const tags = useSelector(
    (state) => state.executiveListingReducer?.companyTagList,
  );

  const onTagConfrim = async () => {
    if (!!tagName) {
      setError(false);
      const payload = {
        employeeIds: selectedRecords,
        tags: [tagName],
        userId: id,
        force: !!isOpen,
      };
      const res = await dispatch(createGroupExecutiveTag(payload));
      if (res?.response?.data?.errorKey === "alreadyTagged") {
        const numbers = res?.response?.data?.title.match(/\d+/g).map(Number);
        if (numbers[0] === numbers[1]) {
          setOpen(
            <>The selected executives are already Tagged in <b>{tagName}</b></>
          );
          setAllTagged(true);
        } else {
          setOpen(
            <>
              {numbers[0]} executives in your selection are already tagged under{" "}
              <b>{tagName}</b>. Would you like to tag the remaining ones?
            </>
          );
        }
      }
      if (res?.length) {
        callback && callback(id);
        showAlert(
          "success",
          <>
            The <b>{tagName}</b> tag has been successfully added to the selected
            executives.
          </>
        );
        closeTagModal();
        setTagValues(null);
        setOpen();
        setExistingTag(true);
      }
    } else {
      setError(true);
    }
  };

  const createNewTag = async () => {
    let payload = {
      employeeIds: selectedRecords,
      tags: [tagName],
      userId: id,
    };
    const res = await dispatch(createGroupExecutiveTag(payload));
    if (res?.length) {
      callback && callback(id);
      showAlert(
        "success",
        <>
          The new tag <b>{tagName}</b> has been successfully created and applied
          to the selected executives.
        </>
      );
      setExistingTag(true);
      setCreateTag(false);
      closeTagModal();
      setTagValues(null);
      setOpen();
    }
  };

  const handleChange = (value) => {
    setError(false);
    setTagValues(value);
    const existingTag = tags?.find((d) => d === value);
    if (value) {
      setExistingTag(!!existingTag);
    } else {
      setExistingTag(true);
    }
  };

  return (
    <Modal
      title={title || "Tag Executive"}
      width="400px"
      closable={true}
      centered={true}
      open={showTagModal}
      onCancel={() => {
        closeTagModal();
        setOpen();
        setTagValues(null);
        setError(false);
        setAllTagged(false);
        setExistingTag(true);
      }}
      footer={
        !!isAllTagged
          ? [
              <Button
                key="ok"
                type="primary"
                onClick={() => {
                  setOpen();
                  setTagValues(null);
                  setError(false);
                  setAllTagged(false);
                  setExistingTag(true);
                }}
              >
                OK
              </Button>,
            ]
          : [
              <Button
                key="cancel"
                onClick={() => {
                  if (isCreateTag) {
                    setCreateTag(false);
                  } else {
                    closeTagModal();
                    setOpen();
                    setTagValues(null);
                    setError(false);
                    setAllTagged(false);
                    setExistingTag(true);
                  }
                }}
              >
                {isOpen ? (isAllTagged ? "" : "No") : "Cancel"}
              </Button>,
              <Button
                key="ok"
                type="primary"
                onClick={() => (isCreateTag ? createNewTag() : onTagConfrim())}
              >
                {isOpen
                  ? isAllTagged
                    ? "OK"
                    : "Yes"
                  : isCreateTag
                    ? "Yes"
                    : "Ok"}
              </Button>,
            ]
      }
    >
      <div className="pop-up errorformcontainer ">
        {isOpen ? (
          <div>
            <div>{isOpen}</div>
          </div>
        ) : (
          <>
            {isCreateTag ? (
              <div>
                Are you sure you want to create the tag named '<b>{tagName}</b>'?
              </div>
            ) : (
              <div className="form">
                <div className="formcol1">
                  <label>Tag Name</label>
                </div>
                <div className="formcol2">
                  <AutoComplete
                    dataSource={tags}
                    value={tagName}
                    allowClear
                    style={{ width: "250px", height: "34px" }}
                    filterOption={(inputValue, option) =>
                      option.props.children
                        .toUpperCase()
                        .indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onSelect={handleChange}
                    onSearch={handleChange}
                  >
                    <Input
                      style={{
                        border: "none",
                        padding: "4.2px 30px 4.2px 11px",
                        fontSize: 12,
                        height: "100%",
                      }}
                      placeholder="Search existing or Add New Tag"
                      suffix={
                        <Tooltip title="Add New Tag">
                          <PlusOutlined
                            style={{
                              visibility: !isExistingTag ? "visible" : "hidden",
                            }}
                            className="heading12px text-theme"
                            onClick={() => setCreateTag(true)}
                          />
                        </Tooltip>
                      }
                    />
                  </AutoComplete>
                  {!!error && (
                    <div className="heading13px" style={{ color: "red" }}>
                      Tag Name is required
                    </div>
                  )}
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </Modal>
  );
};

export default TagExecutive;
